import {
  IVersion,
  IVersionAction,
  IVersionNotification,
  IVersionNotifyAction,
  IVersionNotifyResponse,
} from "../../shared/interfaces/version/IVersion";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { requests } from "../../utils/api/api.service";
import { VERSION_URL } from "../../utils/api/endpoints";

export const VersionService = {
  get: (pagination: IPagination): Promise<IBaseModel<IVersion[]>> =>
    requests.get(VERSION_URL, pagination),
  getSingle: (id: number): Promise<IVersion> =>
    requests.get(`${VERSION_URL}/${id}`),
  create: (params: IVersionAction) => requests.post(VERSION_URL, params),
  update: (params: IVersionAction, id: number) =>
    requests.put(`${VERSION_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${VERSION_URL}/${id}`),
  notify: (
    id: number,
    params: IVersionNotifyAction,
  ): Promise<IVersionNotifyResponse> =>
    requests.post(`${VERSION_URL}/${id}/notify`, params),
  getNotifications: (id: number): Promise<IVersionNotification[]> =>
    requests.get(`${VERSION_URL}/${id}/notifications`),
};
